import React from "react";
import InputField from "../components/common/InputField";
import { FormikProps } from "formik";
import { ProjectDataSchema } from "./projectDataSchema";
import { z } from "zod";

type Props = {
  formik: FormikProps<z.infer<typeof ProjectDataSchema>>;
};

function ProjectNameAndDate(props: Props) {
  const { formik } = props;
  const date = new Date(formik.values.projectStartDate);

  return (
    <div className="flex flex-col gap-4 p-1 max-w-xl">
      <span className="text-sm font-display font-semibold text-slate-900 dark:text-white">
        Définissez le nom et la date de démarrage du projet
      </span>

      <div className="flex flex-col gap-1.5">
        <div className="flex gap-2 items-center">
          <label className="text-xs font-medium text-slate-700 dark:text-slate-300">
            Nom du projet
          </label>
          {formik.errors.project_name && (
            <span className="text-red-500 text-xs">
              *{formik.errors.project_name}
            </span>
          )}
        </div>
        <InputField
          type="text"
          placeholder="Ex: Refonte Plateforme Digitale Q3"
          onChange={formik.handleChange}
          value={formik.values.project_name}
          name="project_name"
        />
      </div>

      <div className="flex flex-col gap-1.5">
        <label className="text-xs font-medium text-slate-700 dark:text-slate-300">
          Date de début
        </label>
        <InputField
          type="date"
          className="!w-fit"
          onChange={(e) =>
            formik.setFieldValue(
              "projectStartDate",
              e.target.value
                ? new Date(e.target.value).toISOString().split("T")[0]
                : ""
            )
          }
          value={
            date && !isNaN(date.getTime())
              ? new Date(date).toISOString().split("T")[0]
              : ""
          }
          name="projectStartDate"
        />
      </div>
    </div>
  );
}

export default ProjectNameAndDate;
